export const PageTitleFirstPayment = 'Seu primeiro pagamento';
export const PageTitleRenewPayment = 'Renovação da assinatura';
export const PageTextFirstPayment = `Para ter acesso a plataforma da Kuppi, confira abaixo com atenção os dados do seu plano e caso esteja tudo
correto efetue o pagamento. Ao efetuar o pagamento, você estará concordando com os nossos termos de uso, `;
export const PageTextRenewPayment = `Para continuar com acesso a plataforma da Kuppi, basta efetuar o pagamento da sua fatura até o vencimento, que é 
$$VALIDITY$$. Ao efetuar o pagamento, você estará concordando com os nossos termos de uso, `;
